import axios from "axios";
import ApiConfig from "../../../api/api.config";

const apiUrl = `${ApiConfig.getEntryPoint()}contexts`;

export const postVisitorsCounter = (friendlyUrl: string) => {
  return axios.post(`${apiUrl}/${friendlyUrl}/visit-counter`);
};
